<div class="flex flex-col gap-2">
  <h6>Zeitraum:</h6>
  <div class="flex flex-col md:flex-row gap-y-8 gap-x-4">
    <div class="w-full">
      <p-floatlabel variant="on">
        <p-datePicker
          inputId="vonDate"
          [formControl]="vonDate"
          [showIcon]="true"
          iconDisplay="input"
          [maxDate]="maxVonDate$ | async"
          view="month"
          dateFormat="mm.yy"
          [required]="true"
          showClear="true"
          fluid
        />
        <label for="vonDate">Von*</label>
      </p-floatlabel>
    </div>
    <div class="w-full">
      <p-floatlabel variant="on">
        <p-datePicker
          inputId="bisDate"
          [formControl]="bisDate"
          [showIcon]="true"
          iconDisplay="input"
          [minDate]="minBisDate$ | async"
          view="month"
          dateFormat="mm.yy"
          showClear="true"
          fluid
        />
        <label for="bisDate">Bis</label>
      </p-floatlabel>
      <small class="form-hint-text"> Leer lassen, wenn noch nicht abgeschlossen </small>
    </div>
  </div>
</div>
